import React, { useEffect } from 'react';
import './Login.scss'
import { setUser, userProfileSelector } from './reducers/UserProfileReducer';
import { useHistory } from 'react-router-dom';
import Utility from '../../app/utility';
import BaseResponse from '../../app/BaseResponse';
import { useDispatch, useSelector } from 'react-redux';
import { loginSelector, setEmail, setPassword } from './reducers/LoginReducer';
import { TextField } from '@mui/material';
import LoginApi, { LoginParam, LoginResponse, ValidateOtpParam } from './api/LoginApi';
import Swal from 'sweetalert2';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';

const Login: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const userProfile = useSelector(userProfileSelector);
    const loginData = useSelector(loginSelector);

    useEffect(() => {
        document.title = "Login";

        //reset data
        dispatch(setEmail(""));
        dispatch(setPassword(""));
    }, []);

    const handleEnterKey = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter" || e.key === "NumpadEnter") {
            submitForm();
        }
    }

    const submitForm = () => {
        try {
            validateForm();

            login();
        } catch (error) {
            Utility.Alert.Error(error);
        }
    };

    const login = () => {
        const loginParam = {
            email: loginData.email,
            password: loginData.password
        } as LoginParam;

        dispatch(showLoading(true));

        LoginApi.Login(loginParam)
            .then((response: BaseResponse<LoginResponse>) => {
                if (response.success) {
                    if (response.data.is2FactorAuthenticationRequired) {
                        showOtpView();
                    } else {
                        dispatch(setUser(response.data.user));

                        history.push("/");
                    }
                } else {
                    Utility.Alert.Error(response.message);
                }
            })
            .catch((error) => {
                let response = error.response.data as BaseResponse<LoginResponse>;
                Utility.Alert.Error(response.message);
            })
            .finally(() => {
                dispatch(showLoading(false));
            })
    };

    const validateForm = () => {
    };

    const showOtpView = () => {
        Swal.fire({
            title: 'Please enter your otp to login',
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Sumbit',
            showLoaderOnConfirm: true,
            allowOutsideClick: false,
            confirmButtonColor: '#1976d2',
            preConfirm: (otp) => {
                if (!otp || otp.length === 0) {
                    Swal.showValidationMessage("Please enter otp")
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(showLoading(true));

                var param = {
                    otp: result.value ? result.value : ""
                } as ValidateOtpParam;
                LoginApi.ValidateOtp(param)
                    .then((response: BaseResponse<LoginResponse>) => {
                        if (response.success) {
                            dispatch(setUser(response.data.user));

                            history.push("/");
                        } else {
                            Utility.Alert.Error(response.message);
                        }
                    })
                    .catch((error) => {
                        let response = error.response.data as BaseResponse<LoginResponse>;
                        Utility.Alert.Error(response.message);
                    })
                    .finally(() => {
                        dispatch(showLoading(false));
                    });
            }
        })
    };

    return (
        <>
            <div className="limiter">
                <div className="container-login100">
                    <div className="wrap-login100">
                        <div className="login100-form">
                            <span className="login100-form-title">
                                Login
                            </span>
                            <div className="wrap-input100">
                                <TextField
                                    label="Email"
                                    onChange={(e) => {
                                        dispatch(setEmail(e.target.value.trim()))
                                    }}
                                    onKeyPress={handleEnterKey}
                                    className="input100"
                                >
                                </TextField>
                            </div>
                            <div className="wrap-input100">
                                <TextField
                                    label="Password"
                                    type="password"
                                    onChange={(e) => {
                                        dispatch(setPassword(e.target.value.trim()))
                                    }}
                                    onKeyPress={handleEnterKey}
                                    className="input100"
                                >
                                </TextField>
                            </div>
                            <div className="container-login100-form-btn">
                                <button
                                    id="submit_login"
                                    className="login100-form-btn"
                                    onClick={submitForm}
                                >
                                    Login
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default Login;